
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "b2c542ac7536a46f0748de8a58df9c89cf9be089",
  "nuxt": {
    "buildId": "cfedb507-b4f3-45fc-ba57-f204fdba30b8"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
